import { ButtonInterface } from "./ButtonInterface";
import { ButtonType } from "./ButtonType";

export class ButtonColor implements ButtonInterface {
  constructor(
    private name: string,
    private color: string,
    private byDefault: boolean,
    private clickable: boolean,
    private clicked = false,
    protected brothersCanUnclick: boolean,
    protected unclickByItself: boolean
  ) { }

  isClicked() {
    return this.clicked;
  }
  setClicked(clicked: boolean) {
    this.clicked = clicked;
  }
  toogleIcon() {
    throw new Error("Method not implemented.");
  }
  toogle() {
    this.clicked = !this.clicked;
  }
  getImage() {
    throw new Error("Method not implemented.");
  }
  getCurrentIcon() {
    throw new Error("Method not implemented.");
  }
  getFriendlyName() {
    return this.name;
  }

  getColor() {
    return this.color;
  }

  getType() {
    return ButtonType.COLOR;
  }

  getByDefault() {
    return this.byDefault;
  }

  canBeSelected() {
    return this.clickable;
  }

  canBrothersUnclick() {
    return this.brothersCanUnclick;
  }

  canUnclickByItself() {
    return this.unclickByItself;
  }
}
